import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(items));
  }, [items]);

  const addItem = (artwork, size = null, material = null, framing = null) => {
    setItems((prev) => {
      const matCode = material?.code || "paper_etching_310";
      const framingKey = framing ? `${framing.code}_${framing.finish_code}` : "no-frame";
      const key = `${artwork.id}__${size?.label || "default"}__${matCode}__${framingKey}`;
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => (i.key === key ? { ...i, quantity: i.quantity + 1 } : i));
      }
      const price = framing ? framing.price : (size ? size.price : artwork.price);
      return [
        ...prev,
        {
          key,
          artwork_id: artwork.id,
          title: artwork.title,
          image_path: artwork.image_path,
          artist_id: artwork.artist_id,
          artist_name: artwork.artist_name,
          price,
          production_cost: artwork.production_cost || 0,
          logistics_cost: artwork.logistics_cost || 0,
          size_label: framing ? `Impresión ${framing.print_label}` : (size?.label || null),
          width_cm: framing ? framing.print_width_cm : (size?.width_cm || null),
          height_cm: framing ? framing.print_height_cm : (size?.height_cm || null),
          material: matCode,
          material_name: material?.name || "Fine Art Etching 310gr",
          framing_code: framing?.code || null,
          framing_finish: framing?.finish_code || null,
          framing_label: framing ? `${framing.finish_label} · ${framing.frame_label}` : null,
          frame_width_cm: framing?.frame_width_cm || null,
          frame_height_cm: framing?.frame_height_cm || null,
          quantity: 1,
        },
      ];
    });
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const updateQty = (key, qty) =>
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, quantity: Math.max(1, qty) } : i)));
  const clear = () => setItems([]);

  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, total, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
